import React from "react";
import { CommentExplorer } from "../../features/comments";
import { CommentType } from "../../services/types";

interface DiscussionCommentsNavigatorProps {
  comments?: CommentType[];
}

/**
 * Transitional compatibility wrapper.
 *
 * Discussion Preview used to maintain its own nested-comment navigator with
 * duplicate tree-building and activity logic. The canonical implementation is
 * now the shared Comment Explorer module used by the main Gist reader.
 *
 * This wrapper intentionally keeps the public component name and props stable,
 * so existing Discussion Preview imports do not need to change in this cleanup
 * patch. It is read-only here because Discussion Preview does not own the full
 * Gist Reader reply/refetch workflow.
 */
const DiscussionCommentsNavigator: React.FC<DiscussionCommentsNavigatorProps> = ({ comments = [] }) => {
  return (
    <CommentExplorer
      gistId={0}
      comments={comments}
      title="Browse this discussion's comments"
      subtitle="Discussion Preview"
      className="is-discussion-preview"
      replyUnavailableMessage="Open the main Gist reader to reply to this comment."
    />
  );
};

export default DiscussionCommentsNavigator;
